var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file_download_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2635",
    "data-name": "Group 2635"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3944",
    "data-name": "Rectangle 3944",
    width: 21,
    height: 21,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2636",
    "data-name": "Group 2636",
    transform: "translate(3.5 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10894",
    "data-name": "Path 10894",
    d: "M16.25,13.625V16.25H5.75V13.625H4V16.25A1.755,1.755,0,0,0,5.75,18h10.5A1.755,1.755,0,0,0,18,16.25V13.625Zm-.875-3.5L14.141,8.891l-2.266,2.257V4h-1.75v7.149L7.859,8.891,6.625,10.125,11,14.5Z",
    transform: "translate(-4 -4)",
    fill: "#4eb6ee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownloadIcon);
export default __webpack_public_path__ + "static/media/file_download_Icon.61c7a78b0256a3d5a37c89c4c6657ece.svg";
export { ForwardRef as ReactComponent };